import PropTypes from "prop-types";
// @mui
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Box,
} from "@mui/material";
// components
import Label from "../../../components/label";
import Scrollbar from "../../../components/scrollbar/Scrollbar";
import { useGetDocumentActionHistoryQuery } from "../../../features/actionLog/actionLogApiSlice";
import { resultColor, formatBytes } from "./fileActionLogUtils";

// ----------------------------------------------------------------------

ActionLogHistoryDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  fileId: PropTypes.string,
  fileName: PropTypes.string,
};

export default function ActionLogHistoryDialog({
  open,
  onClose,
  fileId,
  fileName,
}) {
  const { data: history = [], isFetching } = useGetDocumentActionHistoryQuery(
    fileId,
    { skip: !open || !fileId }
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Verlauf: {fileName || fileId}
        <Typography variant="body2" color="text.secondary">
          Chronologisch, neueste zuerst
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        {isFetching ? (
          <Typography sx={{ py: 3 }}>Wird geladen…</Typography>
        ) : history.length === 0 ? (
          <Typography sx={{ py: 3 }}>
            Keine Protokolleinträge für dieses Dokument.
          </Typography>
        ) : (
          <Scrollbar>
            <Box sx={{ minWidth: 640 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Zeit</TableCell>
                    <TableCell>Benutzer</TableCell>
                    <TableCell>Aktion</TableCell>
                    <TableCell>Ergebnis</TableCell>
                    <TableCell align="right">Größe</TableCell>
                    <TableCell>Notiz</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {history.map((row) => (
                    <TableRow key={row._id} hover>
                      <TableCell>
                        {new Date(row.createdAt).toLocaleString("de-DE")}
                      </TableCell>
                      <TableCell>{row.username || "—"}</TableCell>
                      <TableCell>{row.action}</TableCell>
                      <TableCell>
                        <Label color={resultColor(row.result)}>
                          {row.result}
                        </Label>
                      </TableCell>
                      <TableCell align="right">
                        {formatBytes(row.sizeBytes)}
                      </TableCell>
                      <TableCell>{row.note || "—"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Scrollbar>
        )}
      </DialogContent>
    </Dialog>
  );
}
